import Tooltip from '@cred/react-tooltip'
import { withTooltipInteraction } from '@cred/react-analytics/hoc'

const TooltipWithAnalytics = withTooltipInteraction(Tooltip)
TooltipWithAnalytics.displayName = 'TooltipWithAnalytics'

export default TooltipWithAnalytics
